import { useEffect, useState } from "react";
import { Form, ProgressBar } from "react-bootstrap";
import { useSelector } from "react-redux";
import { getDashboardContactStatisticsCCP } from "../../utils/awsAPI";

const getCurrentTime = () => {
    const today = new Date();
    
    let hoursNum = today.getHours();
    let hoursStr = hoursNum.toString();

    let minNum = today.getMinutes();
    let minStr = minNum.toString();

    let secNum = today.getSeconds();
    let secStr = secNum.toString();

    if (hoursNum < 10) hoursStr = '0' + hoursStr;
    if (minNum < 10) minStr = '0' + minStr;
    if (secNum < 10) secStr = '0' + secStr;
    
    return `${hoursStr}:${minStr}:${secStr}`;
};

const ContactStatsCCP = () => {
    const agentObj = useSelector((state:any)=>{return state.agentSlice.agentObj})
    const [selectedQueue, setSelectedQueue] = useState<any>([])
    const [statsData, setStatsData] = useState<any>({});
    const [channelType, setChannelType] = useState({channel:"All", title:"Contacts"});
    const [percentage, setPercentage] = useState<any>({});
    const [timeFrame, setTimeFrame] = useState({'text': 'Today', 'value':'23', 'localTime':getCurrentTime()});
    
    useEffect(()=>{
        const getDashboardData = async () => {
            let queueIds = [];
            if(selectedQueue.length === 0) {
                let queueList = (agentObj) ? agentObj.getRoutingProfile().queues : []
                let resultQueue = queueList.filter((queue:any) => queue.queueId.indexOf('agent') === -1)
                                            .map((queue:any) => {
                                                let result = queue;
                                                result.isSelected = true;
                                                return result;
                                            })
                setSelectedQueue(resultQueue)
                queueIds = resultQueue.map((queue:any) => queue.queueId)
            } else {
                queueIds = selectedQueue.filter((queue:any) => queue.isSelected === true).map((queue:any) => queue.queueId)
            }
            let channel:any = [];
            if(channelType.channel === "All") {
                channel = ["VOICE", "CHAT"];
            } else if (channelType.channel === "Calls") {
                channel = ["VOICE"]
            } else if (channelType.channel === "Chats") {
                channel = ["CHAT"]
            }
            if(queueIds.length > 0) {
                const CCPStatisticsResponse = await getDashboardContactStatisticsCCP(queueIds, timeFrame.value, channel, timeFrame.localTime);
                if(Object.keys(CCPStatisticsResponse.MetricResults).length > 0) {
                    let displayData:any = {};
                    let total:any = 0;
		    let Fields = ["CONTACTS_QUEUED","CONTACTS_ABANDONED","CONTACTS_HANDLED_INCOMING","CONTACTS_HANDLED_OUTBOUND","API_CONTACTS_HANDLED"];
                    CCPStatisticsResponse.MetricResults[0].Collections.map((stats:any) => {
                        if (stats.Metric.Name !== "CONTACTS_QUEUED"){
                            total = total + stats.Value;
                            displayData[stats.Metric.Name] = stats.Value;
                        }else{
                            
                            displayData[stats.Metric.Name] = stats.Value
                        }
                        return 0;

                    })
                    displayData['TotalValues'] = total;
		    Fields.forEach((element:any) =>{if (!displayData[element]){displayData[element]=0}})
            displayData.CONTACTS_HANDLED_INCOMING = displayData.CONTACTS_HANDLED_INCOMING+ displayData.API_CONTACTS_HANDLED
                    setStatsData(displayData);
                    progressBarCalculation(displayData)
                } else {
                    setStatsData({"CONTACTS_QUEUED":0,"CONTACTS_ABANDONED":0,"CONTACTS_HANDLED_INCOMING":0,"CONTACTS_HANDLED_OUTBOUND":0,"TotalValues":0});
                }
            }
        }
        getDashboardData();
    },[selectedQueue, channelType, timeFrame.value, agentObj])

    const onChannelChange = (channel:any) => {
        setChannelType(channel)
    } 

    const onSelectTimeFrame = (event:any,selectedTimeFrame:string,userLocalTime:any) => {
        
        setTimeFrame({'text': event.target.value, 'value':selectedTimeFrame, 'localTime':userLocalTime})
    }

    const onQueueSelect = (queueData:any, status:any) => {
        let changeStatus = !status;
        let updateData = selectedQueue.map((queue:any) => {
            if(queueData.queueId === queue.queueId) {
                let result = queue
                result.isSelected = changeStatus
                return result
            } else {
                return queue
            }
        })
        setSelectedQueue(updateData)
    }

    const progressBarCalculation = (data:any) => {
        let handledPercentage:any = (data.TotalValues) ? ((data.CONTACTS_HANDLED_INCOMING / data.TotalValues) * 100) : 0;
        let outboundPercentage:any = (data.TotalValues) ? ((data.CONTACTS_HANDLED_OUTBOUND / data.TotalValues) * 100) : 0;
        let abandonPercentage:any = (data.TotalValues) ? ((data.CONTACTS_ABANDONED / data.TotalValues) * 100) : 0;
        let queuedPercentage:any = 0;
        let handledPercentageText:any = (data.TotalValues) ? ((data.CONTACTS_HANDLED_INCOMING / data.TotalValues) * 100).toFixed(0) : 0;
        let outboundPercentageText:any = (data.TotalValues) ? ((data.CONTACTS_HANDLED_OUTBOUND / data.TotalValues) * 100).toFixed(0) : 0;
        let abandonPercentageText:any = (data.TotalValues) ? ((data.CONTACTS_ABANDONED / data.TotalValues) * 100).toFixed(0) : 0;
        let queuedPercentageText:any = (data.TotalValues) ? ((data.CONTACTS_QUEUED / data.TotalValues) * 100).toFixed(0) : 0;
        setPercentage({
            handledValue:{handledPercentage:handledPercentage, handledPercentageText:handledPercentageText},
            outboundValue:{outboundPercentage:outboundPercentage, outboundPercentageText:outboundPercentageText}, 
            AbandonValue:{abandonPercentage:abandonPercentage, abandonPercentageText:abandonPercentageText},
            queuedValue:{queuedPercentage:queuedPercentage, queuedPercentageText:queuedPercentageText}
        })
    }

    return (
        <div className="card contact-sattistcs collapse show mt-3" id="contact_satistic">
            <div className="card-header d-flex justify-content-between align-items-center">
                <h6 className='m-0'>Contact statistics - CCP</h6>
                <div className='d-flex'>
                    <div className="dropdown">
                        <button type="button" className={`btn btn-sm dropdown-toggle`} data-bs-toggle="dropdown">
                            Select queues
                        </button>
                        <ul className="dropdown-menu queues-list">
                            <li>
                                {selectedQueue && selectedQueue
                                    .map((queue:any) => {
                                        return <Form.Check key={queue.name} onChange={() => onQueueSelect(queue, queue.isSelected)} checked={queue.isSelected} label={queue.name} className="dropdown-item" />
                                    })
                                }
                            </li>
                        </ul>
                    </div>
                    <div className="dropdown">
                        <button type="button" className={`btn btn-sm dropdown-toggle`} data-bs-toggle="dropdown">
                            {timeFrame.text}
                        </button>
                        <ul className="dropdown-menu">
                            <li>
                                <button onClick={ (event)=>{onSelectTimeFrame(event,'1',getCurrentTime())} } value="1 Hour" className="dropdown-item">1 hour</button>
                                <button onClick={ (event)=>{onSelectTimeFrame(event,'3',getCurrentTime())} } value="3 Hours" className="dropdown-item">3 hours</button>
                                <button onClick={ (event)=>{onSelectTimeFrame(event,'6',getCurrentTime())} } value="6 Hours" className="dropdown-item">6 hours</button>
                                <button onClick={ (event)=>{onSelectTimeFrame(event,'23',getCurrentTime())} } value="Today" className="dropdown-item">Today</button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="card-body height-200">
                <div className='row'>
                    <div className='col-md-4'>
                        <h6 className="card-title">Total {channelType.title}</h6>
                        <h2>{statsData?.TotalValues}</h2>
                    </div>
                    <div className='col-md-4'>
                        <ul className='list-unstyled'>
                            <li><i className="fa-solid fa-circle text-primary"></i> {channelType.title}  handled {statsData?.CONTACTS_HANDLED_INCOMING ?? 0}</li>
                            <li><i className="fa-solid fa-circle text-success"></i> {channelType.title}  outbound {statsData?.CONTACTS_HANDLED_OUTBOUND ?? 0}</li>
                            <li><i className="fa-solid fa-circle text-danger"></i> {channelType.title} abandoned {statsData?.CONTACTS_ABANDONED ?? 0}</li>
                            <li><i className="fa-solid fa-circle text-warning"></i> {channelType.title} queued {statsData?.CONTACTS_QUEUED ?? 0}</li>
                        </ul>
                    </div>                     
                    <div className='col-md-4'>
                        <div className="form-check">
                        <input onChange={() => {onChannelChange({channel:"All", title:"Contacts"})}} checked={channelType.channel === 'All'} type="radio" className="form-check-input" value="option1" />
                        <label className="form-check-label">View all</label>
                        </div>
                        <div className="form-check">
                        <input onChange={() => {onChannelChange({channel:"Calls", title:"Calls"})}} checked={channelType.channel === 'Calls'} type="radio" className="form-check-input" value="option2" />
                        <label className="form-check-label">Call statistics</label>
                        </div>
                        <div className="form-check">
                        <input onChange={() => {onChannelChange({channel:"Chats", title:"Chats"})}} checked={channelType.channel === 'Chats'} type="radio" className="form-check-input" value="option3" />
                        <label className="form-check-label">Chat statistics</label>
                        </div>
                    </div>
                </div>
                {(percentage?.handledValue?.handledPercentage||percentage?.outboundValue?.outboundPercentage||percentage?.AbandonValue?.abandonPercentage||percentage?.outboundValue?.queuedPercentage) && <div className="row">
                    <div className="col-md-12">
                        <ProgressBar>
                            <ProgressBar bsPrefix="Dass" striped variant="primary" now={percentage?.handledValue?.handledPercentage??0} key={1} label={`${percentage?.handledValue?.handledPercentageText??0}%`} />
                            <ProgressBar  bsPrefix="Dass" striped variant="success" now={percentage?.outboundValue?.outboundPercentage??0} key={2} label={`${percentage?.outboundValue?.outboundPercentageText??0}%`} />
                            <ProgressBar  bsPrefix="Dass" striped variant="danger" now={percentage?.AbandonValue?.abandonPercentage??0} key={3} label={`${percentage?.AbandonValue?.abandonPercentageText??0}%`} />
                            <ProgressBar  bsPrefix="Dass" striped variant="warning" now={percentage?.queuedValue?.queuedPercentage??0} key={4} label={`${percentage?.queuedValue?.queuedPercentageText??0}%`} />
                        </ProgressBar>
			<ProgressBar>
                            <ProgressBar animated striped variant="primary" now={percentage?.handledValue?.handledPercentage??0} key={1}  />
                            <ProgressBar animated striped variant="success" now={percentage?.outboundValue?.outboundPercentage??0} key={2}  />
                            <ProgressBar animated striped variant="danger" now={percentage?.AbandonValue?.abandonPercentage??0} key={3}  />
                            <ProgressBar animated striped variant="warning" now={percentage?.queuedValue?.queuedPercentage??0} key={4} />
                        </ProgressBar>
                    </div>
                </div>}
            </div>
        </div>
    )
}
export default ContactStatsCCP;
